<app-admin-boilerplate>
    @if (lrpEvent$ | async; as lrpEvent){
        <app-event-headline [event]="lrpEvent" admin/>
        <p-tabs [value]="activeTab">
            <p-tablist class="dark:bg-stone-800" styleClass="bg-none">
                    <p-tab value="cateringDetails">Catering Details</p-tab>
                    <p-tab value="menu">Menu</p-tab>
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel value="cateringDetails" header="Catering Details" [formGroup]="cateringForm">
                        <p class="small">If your event is catered you can use these details to inform your players of how catering will work at your event.</p>
                        <p class="small">All the information on these pages will be displayed on a special Catering tab on your event page.</p>
                        <div class="grid grid-cols-3 gap-6">
                            <div class="flex flex-col gap-2">
                                <label for="catererName">Caterer's Name</label>
                                <input id="catererName" type="text" formControlName="catererName" />
                            </div>
                            <div class="flex flex-col gap-2">
                                <label for="catererContact">Contact Details</label>
                                <input id="catererContact" type="text" formControlName="catererContact" placeholder="E-mail address / phone number"/>
                            </div>
                            <div class="flex flex-col gap-2">

                            </div>
                        </div>
                        <label for="cateringNotes">Notes </label>
                        <p-editor id="cateringNotes" formControlName="notes" class="h-40" />
                        <button class="primaryButton mt-16">Save Changes</button>
                    </p-tabpanel>
                    <p-tabpanel value="menu" header="menu">
                        @if (lrpEvent | EventDates; as cateringDays){
                            @for (day of cateringDays; track $index){
                                <div class="grid grid-cols-3">
                                    <div class="text-center">
                                        <h2>{{ day | date:'EEEE'}}</h2>
                                    </div>
                                    
                                </div>
                            }
                        }
                    </p-tabpanel>
                </p-tabpanels>
        </p-tabs>
    }
</app-admin-boilerplate>    